import { Controller } from "@hotwired/stimulus"

// Topbar: mobile drawer toggle + scroll-based shrink/blur.
// Attached on the <header class="topbar-v2"> root.
export default class extends Controller {
  static targets = ["mobileMenu"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundScroll = this.onScroll.bind(this)
    document.addEventListener("click", this.boundClickOutside)
    window.addEventListener("scroll", this.boundScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    window.removeEventListener("scroll", this.boundScroll)
  }

  onScroll() {
    const scrolled = window.scrollY > 24
    this.element.classList.toggle("is-scrolled", scrolled)
  }

  toggleMobileMenu(event) {
    event?.stopPropagation()
    if (!this.hasMobileMenuTarget) return
    this.mobileMenuTarget.hidden = !this.mobileMenuTarget.hidden
  }

  clickOutside(event) {
    if (!this.hasMobileMenuTarget) return
    if (this.mobileMenuTarget.hidden) return
    if (this.element.contains(event.target)) return
    this.mobileMenuTarget.hidden = true
  }
}
